import { MrbBaseRouteStore } from "mrb/core";
import { LoadioContentProfileService } from "common/services";

class LoadioContentProfileEditRouteStore extends MrbBaseRouteStore {
    constructor(rootStore) {
        super(rootStore);
        this.service = rootStore.createApplicationService(LoadioContentProfileService);
    }

    async getProfile(id) {
        const response = await this.service.get(id);
        return response.data;
    }

    async createProfile(resource) {
        const response = await this.service.create(resource);
        return response.data;
    }

    async updateProfile(resource) {
        const response = await this.service.update(resource);
        return response.data;
    }
}

export default LoadioContentProfileEditRouteStore;
